import { createSelector } from 'reselect';
import { sharedSelector } from './base-selector';

export const currentLayoutSelector = createSelector(sharedSelector, state => state.layout.currentLayout);
